import { render, staticRenderFns } from "./organization-terms-of-use-form.vue?vue&type=template&id=4817e6d0&scoped=true"
import script from "./organization-terms-of-use-form.vue?vue&type=script&lang=js"
export * from "./organization-terms-of-use-form.vue?vue&type=script&lang=js"
import style0 from "./organization-terms-of-use-form.vue?vue&type=style&index=0&id=4817e6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817e6d0",
  null
  
)

export default component.exports